import CursedHeader from "./CursedHeader";
import QuoteDesktop from "./DisplayDesktop";
import QuoteMobile from "./DisplayMobile";
import { Client, Quote, User } from "../../types";
import { getAmounts } from "../../utils";

const QuoteDisplay = ({
  quote,
  seller,
  client,
  equipmentMap,
}: {
  quote: Quote;
  seller: User;
  client: Client;
  equipmentMap: Record<string, string>;
}) => {
  const amounts = getAmounts(quote);

  return (
    <div className="print:my-8">
      <div className="border-b border-b-gray-900 text-center py-2 bg-gray-200 print:hidden sticky top-0">
        <button
          className="border rounded bg-white py-0.5 px-4 border-neutral-900"
          onClick={() => window.print()}
        >
          Imprimir
        </button>
      </div>

      <CursedHeader />

      <div className="hidden quote:block print:block">
        <QuoteDesktop
          quote={quote}
          amounts={amounts}
          seller={seller}
          client={client}
          equipmentMap={equipmentMap}
        />
      </div>

      <div className="quote:hidden print:hidden">
        <QuoteMobile
          quote={quote}
          amounts={amounts}
          seller={seller}
          client={client}
          equipmentMap={equipmentMap}
        />
      </div>
    </div>
  );
};

export default QuoteDisplay;
